import { render, staticRenderFns } from "./LayoutLeagues.vue?vue&type=template&id=b26aa9c0&scoped=true&"
import script from "./LayoutLeagues.vue?vue&type=script&lang=js&"
export * from "./LayoutLeagues.vue?vue&type=script&lang=js&"
import style0 from "./LayoutLeagues.vue?vue&type=style&index=0&id=b26aa9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26aa9c0",
  null
  
)

export default component.exports